import { default as Box } from './Box';

export default Box;
